<div class="modal-wrapper" (keydown.enter)="$event.preventDefault()">
  <div class="modal-title" mat-dialog-title>
    <div class="text">Enter PIN</div>
    <div class="close">
      <app-close-btn (click)="closeDialog()"></app-close-btn>
    </div>
    <div class="hr"></div>
  </div>
  <div class="modal-content" mat-dialog-content>
    <div class="heading">This is a private Fundraiser. Please enter the PIN to continue.</div>
    <form class="form" [formGroup]="pinForm" (ngSubmit)="formSubmit()" (keydown.enter)="formSubmit()">
      <div class="input-wrapper" formGroupName="pin" [ngClass]="{ 'not-allowed': isLoading }">
        <input type="text" class="input" maxlength="1" #inpRef1 formControlName="pinDigit1" (keyup)="changeInput(null, inpRef1, inpRef2, $event)">
        <input type="text" class="input" maxlength="1" #inpRef2 formControlName="pinDigit2" (keyup)="changeInput(inpRef1, inpRef2, inpRef3, $event)">
        <input type="text" class="input" maxlength="1" #inpRef3 formControlName="pinDigit3" (keyup)="changeInput(inpRef2, inpRef3,inpRef4, $event)">
        <input type="text" class="input" maxlength="1" #inpRef4 formControlName="pinDigit4" (keyup)="changeInput(inpRef3, inpRef4, inpRef5, $event)">
        <input type="text" class="input" maxlength="1" #inpRef5 formControlName="pinDigit5" (keyup)="changeInput(inpRef4, inpRef5, inpRef6, $event)">
        <input type="text" class="input" maxlength="1" #inpRef6 formControlName="pinDigit6" (keyup)="changeInput(inpRef5, inpRef6, null, $event)">
      </div>
      <mat-error *ngIf="isRequiredError" class="d-flex justify-content-center">Field is required</mat-error>
      <mat-error *ngIf="isPatternError" class="d-flex justify-content-center">Alpha numeric values only</mat-error>
      <div class="info-text">If you do not have the pin, please contact the campaign owner</div>
      <div *ngIf="showCaptcha">
        <app-captcha-input type="dialog" [control]="pinForm.get('captcha')" size="invisible" [execute]="true" #captchaRef></app-captcha-input>
      </div>
      <div class="hr mt-2"></div>
      <div class="actions mt-3">
        <button mat-button class="primary-btn submit-btn" [ngClass]="{'disabled': disableSubmitBtn}" type="submit" [disabled]="isLoading || disableSubmitBtn">
          <div *ngIf="!isLoading">Enter</div>
          <div *ngIf="isLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        </button>
      </div>
    </form>
  </div>
</div>
